import { render } from "./ModalCustomerDetails.vue?vue&type=template&id=2d105167&scoped=true"
import script from "./ModalCustomerDetails.vue?vue&type=script&lang=js"
export * from "./ModalCustomerDetails.vue?vue&type=script&lang=js"

import "@/assets/css/newdesign.scss?vue&type=style&index=0&id=2d105167&lang=scss&scoped=true"
import "./styles/ModalCustomerDetails.scss?vue&type=style&index=1&id=2d105167&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d105167"]])

export default __exports__